import axios from "../../config/axiosConfig";
import { GRAY_JOB_RECEIVE_RETURN_TRANSACTION_REQUEST, GRAY_JOB_RECEIVE_RETURN_TRANSACTION_REQUEST_FAILURE, GET_GRAY_JOB_RECEIVE_RETURN_TRANSACTIONS_TAKA_NO,
  GET_GRAY_JOB_RECEIVE_RETURN_AVAILABLE_TRANSACTIONS, GET_GRAY_JOB_RECEIVE_RETURN_TRANSACTIONS } from "../types";

export const getGrayJobReceiveReturnTransactions = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GRAY_JOB_RECEIVE_RETURN_TRANSACTION_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
      return axios.get("/gray-job-return-transaction/getAll", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_GRAY_JOB_RECEIVE_RETURN_TRANSACTIONS, payload: response.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: GRAY_JOB_RECEIVE_RETURN_TRANSACTION_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: GRAY_JOB_RECEIVE_RETURN_TRANSACTION_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getGrayJobReceiveReturnTransactionTakaNo = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GRAY_JOB_RECEIVE_RETURN_TRANSACTION_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id };
      if (!auth?.company?.Common_Company) {
        params = { ...params, companyId: auth.company?.id }
      }
      return axios.get("/gray-job-return-transaction/getAll", { params }).then((response) => {
        const takaNos = response.data.map((data) => data.Taka_No);
        if (response.data) {
          dispatch({ type: GET_GRAY_JOB_RECEIVE_RETURN_TRANSACTIONS_TAKA_NO, payload: takaNos });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: GRAY_JOB_RECEIVE_RETURN_TRANSACTION_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: GRAY_JOB_RECEIVE_RETURN_TRANSACTION_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getGrayJobReceiveReturnAvailableTransactions = (queryParams) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GRAY_JOB_RECEIVE_RETURN_TRANSACTION_REQUEST });
      const { auth } = getState();
      let params = { ...queryParams, finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };

      return axios.get("/gray-job-return/get-available-transactions", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_GRAY_JOB_RECEIVE_RETURN_AVAILABLE_TRANSACTIONS, payload: response.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: GRAY_JOB_RECEIVE_RETURN_TRANSACTION_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: GRAY_JOB_RECEIVE_RETURN_TRANSACTION_REQUEST_FAILURE, error: error.message });
    }
  };
};

